import { AxiosResponse } from 'axios';
import { CommonResponse } from '@auth_module/services';

export function responseOk(response: AxiosResponse<CommonResponse>) {
  return response.status >= 200 && response.status < 300;
}

export function trimTrailingSlash(url: string) {
  return url?.endsWith('/') ? url?.slice(0, -1) : url;
}
